import * as React from 'react';
import * as ReactDOM from 'react-dom';
import thunk from 'redux-thunk'
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import App from './components/App';
import ErrorBoundary from './components/Ui/ErrorBoundary';
import { rootReducer } from './store/reducers/RootReducer';
import { BrowserRouter } from 'react-router-dom';
import { composeWithDevTools } from 'redux-devtools-extension';
import { config } from './config';


export const store = createStore(
  rootReducer,
  composeWithDevTools(
    applyMiddleware(thunk)
  )
);

const persistor = persistStore(store);

const Root = () => {
  return (
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
};

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter basename={config.mountPath}>
        <Root />
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);
